<template>
  <div class="boxExtrato">
    <Topo class="naoImprimir" v-if="!$verificaPerfilHabilitador() && !$verificaPerfilCadastrador()" :btnLogout="true" :acessoRestritoMenu="false"></Topo>
    <CabecalhoImpressao class="imprimir" hidden></CabecalhoImpressao>
    <Migalha class="naoImprimir" v-if="!$verificaPerfilHabilitador() && !$verificaPerfilCadastrador()" label="Cadastro Fornecedor"></Migalha>

    <v-layout row wrap>
      <v-flex xs4>
        <br>
        <div class="right p-l-10">
          <v-btn 
          slot="activator" 
          v-if="!$verificaPerfilHabilitador() && 1 == 2" 
          color="primary" 
          class="mb-2" 
          v-print> Imprimir removido
            <v-icon dark right>print</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs4>
        <br>
        <div class="left p-l-10">
          <v-btn 
          slot="activator" 
          v-if="$verificaPerfilHabilitador()" 
          color="primary" 
          class="mb-2" 
          @click="solicitarAlteracao()">
          Solicitar Alteração
            <v-icon dark right>edit</v-icon>
          </v-btn>
        </div>
      </v-flex>

      <v-flex xs8 md6 text-xs-center nomeFornecedor v-if="modelCarregado">
        <div class="boxConteudoNomeFornecedor">
          <h3 class="display-1 text-primary">{{model.nomFornecedor }}</h3>
          <div class>
            <strong>{{(model.tipFornecedor =='J') ? $t('label.pessoaJurica') : $t('label.pessoaFisica')}}</strong>
          </div>
          <div class>
            <span v-if="model.flagEstrangeiro==0">{{(model.tipFornecedor =='J') ? $t('label.cnpj') : $t('label.cpf')}}:</span>
            <span v-else>{{$t('label.documentoIdentificacao')}}: </span>
            <strong>
              {{ model.tipFornecedor === 'J'
                  ? formatCNPJ(model.numCgcFornecedor)
                  : formatCPF(model.numCgcFornecedor) }}
            </strong>
            <br>
            <div v-if="$verificaPerfilHabilitador()">
              <span >Processo SEI:<strong>{{model.numProcedimentoSEI}}</strong></span>
              <span style="float:center; padding:0px 0 0 0;" >
                <a v-show="model.linkProcedimentoSEI">
                  <v-tooltip top >
                      <img @click="redirecionaLinkSEI(model.linkProcedimentoSEI)" class="mx-1" slot="activator"
                        style="height: 20px; width:30px"  src="../../../assets/logo_sei.png"/>
                    <span>Acessar Documentos no SEI</span>
                  </v-tooltip>
                </a>
              </span>
            </div> 
          </div>
          <div class>
            Tipo de Cadastro:
            <strong>{{retornaEnumDescricao("tipoCertificado",model.tipoCertificado)}}{{(model.tipoCertificado != 3) ? ' - ' + model.tbFornecedores.vwCRC.numCrc : ''}}</strong>
          </div>
          <div class v-if="model.tipoCertificado != 3">
            Validade:
            <strong>{{model.tbFornecedores.vwCRC.datVencimentoCrc | dataFormatada}}</strong>
          </div>
          <div class>
            Categoria:
            <strong>{{retornaCategoria(model.categoria)}}</strong>
          </div>
        </div>
      </v-flex>

      <v-flex xs4 md6 class="textoBoasVindas">
        <div  v-if="modelCarregado">
          <h1 class="text-red">
            <strong class="text-uppercase">{{$t('label.extrato')}}</strong>
          </h1>
          <div class="tituloStatusCadastro text-md-center font-size-12">
            <strong>
              {{$t('titulo.statusDoCadastroExtrato')}}:
             
              <span class="text-atencao"
                >{{retornaEnumDescricao("situacaoFornecedor", model.sitFornecedor)}}
              </span>
            </strong>
           
          </div>
          <!--<div class="tituloStatusCadastro text-md-center font-size-18">
             <strong>                        
              <v-btn  @click="termoConcordancia(model)" v-if="this.model.tiposolicitacao != 1 && $store.getters.getPerfil == 'fornecedor' " >Termo de Concordância e Veracidade</v-btn>                
            </strong>            
              </div>-->
        </div>

      <br>
      <!-- 
        Emerson Santana
        RedMine #121533 essa solicitação foi removida 
        para ser recriada em um novo chamado com uma especificação detalhada do processo


      <div v-if=" ( $store.getters.getPerfil == 'habilitador' ) || ( this.model.tiposolicitacao != 1 && $store.getters.getPerfil == 'fornecedor' )">
        
        <UploadArquivoSEI :idFornecedor="model.numCgcFornecedor" :tipoArquivo="codigo_arquivo_sei">
        </UploadArquivoSEI>
        
      </div>
    
      <div v-if="documentoTermoVeracidade && documentoTermoVeracidade.numDocumentoSEI && documentoTermoVeracidade.linkDocumentoSEI">
        
            <strong>
              <a  @click="baixarArquivo(documentoTermoVeracidade.linkDocumentoSEI)">
                Download Termo de Veracidade
                <v-icon color="blue">attach_file</v-icon>
              </a>
                      
            </strong>
      </div>
      -->

      </v-flex>
    </v-layout>
    <br><br><br><br>
    <dadosBasicos :model="model" :enums="enums" :dominio="dominio" v-if="modelCarregado"></dadosBasicos>
    <habilitacaoJuridica
      :model="model"
      :enums="enums"
      :dominio="dominio"
      v-show="model.tipFornecedor != 'F'"
      v-if="modelCarregado"
    ></habilitacaoJuridica>
    <familia :model="model" :enums="enums" :dominio="dominio" :disable-pagination="true" v-if="modelCarregado"></familia>
    <qualificacaoTecnica :model="model" :enums="enums" :dominio="dominio" v-if="modelCarregado"></qualificacaoTecnica>
    <regularidadeFiscal :model="model" :enums="enums" :dominio="dominio" v-if="modelCarregado"></regularidadeFiscal>
    <qualificacaoEconomica
      :model="model"
      :enums="enums"
      :dominio="dominio"
      v-if="modelCarregado"
      v-show="model.tipoCertificado != '3'"
    ></qualificacaoEconomica>
    <formulariosDeclaracoes :model="model" :enums="enums" :dominio="dominio" v-if="modelCarregado"></formulariosDeclaracoes>
    
    <br><br>
    <RodapeImpressao class="imprimir" hidden></RodapeImpressao>
  </div>
</template>

<script>
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import dominioService from "../../../services/dominioService";
import Migalha from "../../../components/migalha";
import Topo from "../../../components/Topo";
// import UploadArquivoSEI from "../../../components/UploadArquivoSEI";
// import dadosBasicos from "./extrato-dados-basicos";
import dadosBasicos from "../../fornecedor/resumo/resumo-dados-basicos.vue";
import familia from "./extrato-familia";
import qualificacaoTecnica from "./extrato-qualificacao-tecnica";
import habilitacaoJuridica from "./extrato-habilitacao-juridica";
import regularidadeFiscal from "./extrato-regularidade-fiscal";
import qualificacaoEconomica from "./extrato-qualificacao-economica";
import formulariosDeclaracoes from "./extrato-formularios-declaracoes";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import Print from "vue-print-nb";
import CabecalhoImpressao from "../../../components/cabecalho-impressao";
import RodapeImpressao from "../../../components/rodape-impressao";
import Vue from "vue";

export default {
  name: "fornecedor-extrato",
  mixins: [util],
  components: { /*Componentes utilizados*/
    /*mascote,*/
    Migalha,
    Topo,
    dadosBasicos,
    habilitacaoJuridica,
    familia,
    qualificacaoTecnica,
    regularidadeFiscal,
    qualificacaoEconomica,
    formulariosDeclaracoes,
    CabecalhoImpressao,
    RodapeImpressao,
    // UploadArquivoSEI

  },
  props: {//Propriedades que o objeto recebe como parametro
    numCgcFornecedorProp: Object,
  },

  data() {//Declaracao de variaveis
    return {
      
      codigo_arquivo_sei: window.localStorage.getItem("id_tipo_documento_sei"),
      enums: {
        tipoCertificado: []
      },
      valid: true,
      model: {},
      dominio: {
        categoria: [],
        paises: []
      },
      documentoTermoVeracidade: null,
      mascote: {
        msg: "Envio realizado com sucesso.",
        percent: 0
      },
      modelCarregado: false
    };
  },

  watch: { //Propriedades assistidas
    "$route.params.id"() {
      this.inicializar();
    }
  },

  created() /*Metodo de start do componente*/{
    this.inicializar();
    Vue.use(Print);
  },
  methods: {//Declaracao de todos os metodos
    inicializar() {

      this.getFornecedorSIMPAS();
      this.$store.getters.getPerfil
      this.getCombosDadosBasicos();
      dominioService.geEnums().then(response => { /*resposta do servico*/
        this.enums = response.data; /*dados de retorno*/
      });
    },

    getCombosDadosBasicos() {
      //resgatar os combos de dados basicos
      dominioService.getCombosDadosBasicos().then(response => { /*resposta do servico*/
        this.dominio = response.data; /*dados de retorno*/
      });
    },

    getFornecedorSIMPAS() {
      //resgatar os dados do fornecedor
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      let numCgcFornecedor =
        this.$route.params.id && this.$verificaPerfilHabilitador()
          ? this.$route.params.id
          : null;
      numCgcFornecedor = this.numCgcFornecedorProp ? this.numCgcFornecedorProp.texto : numCgcFornecedor

      fornecedorService.getFornecedorSIMPAS(numCgcFornecedor).then(response => { /*resposta do servico*/
        this.model = response.data; /*dados de retorno*/
        this.modelCarregado = true;
        this.documentoTermoVeracidade = this.model.tbFornecedores.documentosFornecs.find(x=> x.codDocumento == this.codigo_arquivo_sei);
        this.$removePreload(); /*Ocultar o PreLoad*/
      });
    },

    aliasDescSituacao(valor) {
      //substituir os nomes dos enums
      switch (this.retornaEnumChave("situacaoSolicitacao", valor)) {
        case "PendenteEnvio":
          return this.retornaEnumDescricao("situacaoSolicitacao", valor);
        case "Enviado":
          return "Aguardando Análise";
        case "EmAnalise":
          return this.retornaEnumDescricao("situacaoSolicitacao", valor);
        case "IniciadoPorCadastrador":
          return this.retornaEnumDescricao("situacaoSolicitacao", valor);
        case "Ativo":
          return "Deferida";
        case "Rejeitado":
          return "Indeferida";
        default:
          return valor != null
            ? this.retornaEnumDescricao("situacaoSolicitacao", valor)
            : null;
      }
    },

    retornaEnumChave(_enum, valor) {
      //retornar a chave do enum
      if (valor == null || this.enums[_enum] == null) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.chave : null;
    },

    retornaEnumDescricao(_enum, valor) {
      //retorna a descricao do enum
      if (valor == null || !this.enums[_enum] == null) return "";

      // condição para que não busque (.find) num enum vazio e dê erro
      if(this.enums[_enum] && this.enums[_enum] != undefined && this.enums[_enum] !== ""){
        let retorno = this.enums[_enum].find(x => x.valor === valor);
        //verificar se retorno foi preenchido
        if (retorno)
          return retorno.descricao;
        else
          return null;
      } else {
        return null;
      }
    },

    retornaCategoria(cod_categoria) {
      //retorna a categoria
      if (!cod_categoria) return "";
      let categoria = this.dominio.categoria.find(
        x => x.categoria === cod_categoria
      );
      return categoria ? categoria.descricao : null;
    },
    historicoSolicitar(){

       this.$emit("voltarhistorico","tab-comprasnet")

    },

    solicitarAlteracao() {

      //solicitar uma alteração de cadastro
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      if(this.model.sitFornecedor === 5) /*se a situação for Suspenso indeterminado*/
      {
        this.$removePreload();
        this.$toasted.error(this.$t('messages.validacao.situacaoFornecedorSuspenso'));
        return;
      }
      if(this.$verificaPerfilHabilitador()){

        fornecedorService.solicitarAlteracaoHabilitador(this.numCgcFornecedorProp.texto).then(response => { /*resposta do servico*/
          this.$router.push({
            path: "/arearestrita/habilitador/consultar-solicitacao/" + response.data.novoModel.idFornecSolicitacao ,
          });
          this.$removePreload();
        });

      }
      if(this.$verificaPerfilCadastrador())
      {
        fornecedorService.solicitarAlteracao(this.numCgcFornecedorProp.texto).then(() => { /*resposta do servico*/

        this.$router.push({
          path: `/cadastro/modificar/${this.numCgcFornecedorProp.texto}`,
        });

        });
        this.$removePreload();
      }

    },
    
     termoConcordancia() {
      //fechar a caixa de dialogo e redirecionar para a home   
      this.$router.push("termo-declaracao-concordancia/"+ this.model.tbFornecedores.fornecedorSolicitacao[0].idFornecSolicitacao); 
    },

     redirecionaLinkSEI(endereco){
       //abre nova guia com o procedimento SEI
       const link = document.createElement('a');
       var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-/]))?/;
        if(regex .test(endereco)) {
            link.href = endereco;
            link.setAttribute('download', endereco);
            link.setAttribute('target', "_blank");
            document.body.appendChild(link);
            link.click();
            return true;
        }
        return false;
    },
    baixarArquivo(arquivo) {
      const numCgcFornecedor = this.$verificaPerfilCadastrador()
        ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "")
        : null;
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },
    formatCNPJ(value) {
      if (!value) return "";     
   
      let chars = value.toString().replace(/[^A-Za-z0-9]/g, "").toUpperCase();
     
      chars = chars.padStart(14, "0");
    
      return chars.replace(/^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})$/, "$1.$2.$3/$4-$5");
    },
    formatCPF(value) {
      if (!value) return "";
      return value
        .toString()
        .replace(/\D/g, "")
        .replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    }
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.textoBoasVindas h1 {
  font-size: 40px;
}

.nomeFornecedor {
  position: relative;
}

.boxConteudoNomeFornecedor {
  background: url("/images/bg1.png") repeat center center;
  border: 1px solid #cdcdcd;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translateY(-25%);
  width: calc(100% - 30px);
  z-index: 999;
  padding: 10px 0;
}
</style>
<style scoped> /*CSS especifico do componente*/
.theme--light.v-table thead {
  background: none;
  color: red;
}
</style>

<style>
.boxExtrato .theme--light.v-table thead {
  background: none;
      @page {
        width: 100% !important;
        max-width: none !important;
    }
}
.dataVencida {
  color: red !important;
}
</style>
